<template>
  <b-modal
    id="food-animal-create-modal"
    ref="modal"
    :title="'Ajouter un aliment pour '+animal.name"
    @show="resetModal"
    @hidden="resetModal"
    @ok="handleOk"
    ok-title="Ajouter"
    cancel-title="Annuler"
  >
    <form ref="form" @submit.stop.prevent="handleSubmit">
      <b-form-group
        class="mt-2 mb-0"
        label-for="food-input"
        :invalid-feedback="food.invalidFeedback"
        :state="food.state"
      >
        <b-form-select
          id="food-input"
          :options="foodsOptions"
          :state="food.state"
          v-model="food.value"
          required
        ></b-form-select>
      </b-form-group>
    </form>
  </b-modal>
</template>

<script>
import api from '../../services/api';

export default {

  name: 'FoodAnimalCreateModal',

  props: {

    animal: {
      type: Object,
      required: true
    }

  },

  emits: ['didSaveFoodAnimal'],

  data: function () {
    return {
      notAvailableFoods: [],
      food: {
        value: null,
        state: null,
        invalidFeedback: null
      }
    }
  },

  computed: {
    foodsOptions() {
      let options = [{value: null, text: 'Sélectionner aliment', disabled: true}]
      if (!this.notAvailableFoods || this.notAvailableFoods.length === 0) {
        return options
      }

      this.notAvailableFoods.filter(item => item).map(food => {
        options.push({
          value: food.id,
          text: food.name
        })
      })
      return options
    }
  },

  methods: {

    resetModal() {
      this.food.value = null
      this.food.state = null
      this.food.invalidFeedback = null
      this.notAvailableFoods = []
      this.fetchNotAvailableFoods()
    },

    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault() // Prevent modal from closing
      this.handleSubmit()
    },

    fetchNotAvailableFoods() {
      api
        .get(`/food?notAvailableForAnimalId=${this.animal.id}`)
        .then(response => {
          this.notAvailableFoods = response.data
        })
    },

    handleSubmit() {
      if (!this.isFormValid()) {
        return
      }

      let data = new FormData()
      data.append('animalId', this.animal.id)
      data.append('foodId', this.food.value)

      api({
        method: 'POST',
        url: 'foodAnimal',
        data: data
      })
        .then((response) => {
          this.$emit('didSaveFoodAnimal')
          this.resetModal()
          this.hideModal()
          this.successToast(response.data)
        })
        .catch((error) => {
          console.log('Error on save category', error)
        });

    },

    hideModal() {
      this.$bvModal.hide('food-animal-create-modal')
    },

    isFormValid() {
      const valid = this.$refs.form.checkValidity()
      this.food.state = valid
      this.food.invalidFeedback = 'Ce champ est requis'
      return valid
    },

    successToast(food) {
      this.$bvToast.toast(`Aliment \"${food.name}\" ajouté`, {
        autoHideDelay: 20000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    }
  }
}
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/views/foodAnimal/FoodAnimalCreateModal.vue